module.exports = __webpack_public_path__ + "static/media/HomeFurnishing2.36dfebf9.png";